import Vue from "vue";

const objs = {};
const configs = [];
const $http = Vue.prototype.$http;
const $jHttp = Vue.prototype.$jHttp;

configs.push({
    key: "login",
    path: "/api/login",
    method: "post",
});
configs.push({
    key: "logout",
    path: "/api/logout",
    method: "post",
});
configs.push({
    key: "userCenter",
    path: "/api/user/center",
    method: "get",
});
configs.push({
    key: "updateAvatar",
    path: "/api/user/avatar",
    method: "post",
});
configs.push({
    key: "updateNickname",
    path: "/api/user/nickname",
    method: "post",
});
configs.push({
    key: "updateAge",
    path: "/api/user/age",
    method: "post",
});
configs.push({
    key: "agoraToken",
    path: "/api/agora/token",
    method: "get",
});
configs.push({
    key: "agoraToken1",
    path: "/api/agora/token1",
    method: "get",
});
configs.push({
    key: "agoraUsage",
    path: "/api/agora/usage",
    method: "get",
});
configs.push({
    key: "analyseCourse",
    path: "/api/analyse/course",
    method: "get",
});
configs.push({
    key: "analyseBook",
    path: "/api/analyse/book",
    method: "get",
});
configs.push({
    key: "analyseLog",
    path: "/api/analyse/log",
    method: "get",
});
configs.push({
    key: "analyseFriend",
    path: "/api/analyse/friend",
    method: "get",
});
configs.push({
    key: "analyseUser",
    path: "/api/analyse/user",
    method: "get",
});
configs.push({
    key: "analyseRate",
    path: "/api/analyse/rate",
    method: "get",
});
configs.push({
    key: "courseCancel",
    path: "/api/course/cancel",
    method: "post",
});
configs.push({
    key: "attention",
    path: "/api/attention",
    method: "post",
});
configs.push({
    key: "courseSync",
    path: "/api/course/sync",
    method: "post",
});
configs.push({
    key: "videoReady",
    path: "/api/video/ready",
    method: "post",
});
configs.push({
    key: "videoStart",
    path: "/api/video/start",
    method: "post",
});
configs.push({
    key: "videoStop",
    path: "/api/video/stop",
    method: "post",
});
configs.push({
    key: "workFinish",
    path: "/api/work/finish",
    method: "post",
});
configs.push({
    key: "friendSearch",
    path: "/api/friend/search",
    method: "get",
});
configs.push({
    key: "easemobFriend",
    path: "/api/friend/easemob",
    method: "get",
});
configs.push({
    key: "fileUpload",
    path: "/api/file/upload",
    method: "post",
});
configs.push({
    key: "fileEditor",
    path: "/api/file/editor",
    method: "post",
});
configs.push({
    key: "sysSend",
    path: "/api/easemob/syssend",
    method: "post",
});
configs.push({
    key: "versionAndroid",
    path: "/api/version/android",
    method: "get",
});
configs.push({
    key: "easemobAllGroup",
    path: "/api/easemob/allgroup",
    method: "get",
});
configs.push({
    key: "allMyFriends",
    path: "/api/friend/allfriend",
    method: "get",
});
configs.push({
    key: "rateVolunteer",
    path: "/api/rate/volunteer",
    method: "post",
});
configs.push({
    key: "rateStudent",
    path: "/api/rate/student",
    method: "post",
});
configs.push({
    key: "rateCourse",
    path: "/api/rate/course",
    method: "post",
});
configs.push({
    key: "onlineTotal",
    path: "/api/online/total",
    method: "get",
});
configs.push({
    key: "analyseEvaluationList",
    path: "/api/analyse/evaluation/list",
    method: "get",
});
configs.push({
    key: "analyseEvaluationAppend",
    path: "/api/analyse/evaluation/append",
    method: "post",
});
configs.push({
    key: "analyseEvaluationUpdate",
    path: "/api/analyse/evaluation/update",
    method: "post",
});
configs.push({
    key: "analyseEvaluationRemove",
    path: "/api/analyse/evaluation/remove",
    method: "post",
});
configs.push({
    key: "analyseInterviewList",
    path: "/api/analyse/interview/list",
    method: "get",
});
configs.push({
    key: "analyseInterviewAppend",
    path: "/api/analyse/interview/append",
    method: "post",
});
configs.push({
    key: "analyseInterviewUpdate",
    path: "/api/analyse/interview/update",
    method: "post",
});
configs.push({
    key: "analyseInterviewRemove",
    path: "/api/analyse/interview/remove",
    method: "post",
});
configs.push({
    key: "interviewoutlineList",
    path: "/api/analyse/interviewoutline/list",
    method: "get",
});
configs.push({
    key: "interviewoutlineAppend",
    path: "/api/analyse/interviewoutline/append",
    method: "post",
});
configs.push({
    key: "interviewoutlineUpdate",
    path: "/api/analyse/interviewoutline/update",
    method: "post",
});
configs.push({
    key: "interviewoutlineRemove",
    path: "/api/analyse/interviewoutline/remove",
    method: "post",
});
configs.push({
    key: "interviewoutlineVolunteerList",
    path: "/api/analyse/interviewoutline_volunteer/list",
    method: "get",
});
configs.push({
    key: "interviewoutlineVolunteerAppend",
    path: "/api/analyse/interviewoutline_volunteer/append",
    method: "post",
});
configs.push({
    key: "interviewoutlineVolunteerUpdate",
    path: "/api/analyse/interviewoutline_volunteer/update",
    method: "post",
});
configs.push({
    key: "interviewoutlineVolunteerRemove",
    path: "/api/analyse/interviewoutline_volunteer/remove",
    method: "post",
});
configs.push({
    key: "questionnaireList",
    path: "/api/questionnaire/list",
    method: "get",
});
configs.push({
    key: "questionnaireAppend",
    path: "/api/questionnaire/append",
    method: "post",
});
configs.push({
    key: "questionnaireUpdate",
    path: "/api/questionnaire/update",
    method: "post",
});
configs.push({
    key: "questionnaireRemove",
    path: "/api/questionnaire/remove",
    method: "post",
});
configs.push({
    key: "questionnaireResultList",
    path: "/api/questionnaire/result/list",
    method: "get",
});
configs.push({
    key: "userScore",
    path: "/api/user/score",
    method: "get",
});
configs.push({
    key: "resultUpload",
    path: "/api/questionnaire/result/upload",
    method: "post",
});
configs.push({
    key: "qiniuRemove",
    path: "/api/qiniu/remove",
    method: "post",
});
configs.push({
    key: "maintenanceList",
    path: "/api/maintenance/list",
    method: "get",
});
configs.push({
    key: "easeMob",
    path: "/api/easemob/save",
    method: "post",
});
configs.push({
    key: "hxtime",
    path: "/api/easemob/hxtime",
    method: "get",
});
configs.push({
    key: "hxprogress",
    path: "/api/easemob/progress",
    method: "get",
});
configs.push({
    key: "classExport",
    path: "/api/class/export",
    method: "post",
});
configs.push({
    key: "pblExport",
    path: "/api/pbl/export",
    method: "post",
});
configs.push({
    key: "backUp",
    path: "/api/backup",
    method: "post",
});
configs.push({
    key: "check",
    path: "/api/check",
    method: "post",
});
configs.push({
    key: "checkPjdyu",
    path: "/api/checkPjdyu",
    method: "post",
});
configs.push({
    key: "beforeClass",
    path: "/api/beforeClass",
    method: "post",
});
configs.push({
    key: "afterClass",
    path: "/api/afterClass",
    method: "post",
});
configs.push({
    key: "parentagree",
    path: "/api/parentagree",
    method: "post",
});
configs.push({
    key: "chooseVolunteer",
    path: "/api/chooseVolunteer",
    method: "post",
});
configs.push({
    key: "activityVolunteer",
    path: "/api/activity/volunteer",
    method: "get",
});
configs.push({
    key: "cancelVolunteer",
    path: "/api/cancel/volunteer",
    method: "post",
});
configs.push({
    key: "volunteerRelation",
    path: "/api/volunteerRelation",
    method: "get",
});
configs.push({
    key: "volunteerRelationAppend",
    path: "/api/vlounteerRelation/append",
    method: "post",
});
configs.push({
    key: "volunteerRelationDelete",
    path: "/api/vlounteerRelation/delete",
    method: "post",
});
configs.push({
    key: "resetPassword",
    path: "/api/resetPassword",
    method: "post",
});
// 志愿者表单
configs.push({
    key: "activityWeekFrom",
    path: "/api/activityWeekFrom",
    method: "get",
});
configs.push({
    key: "avisCheck",
    path: "/api/volunteer/isCheck",
    method: "post",
});
configs.push({
    key: "activityCrousList",
    path: "/api/activity/videoList",
    method: "get",
});
configs.push({
    key: "activityCrousUpdate",
    path: "/api/activity/videUpdate",
    method: "post",
});
configs.push({
    key: "classfeedbackSend",
    path: "/api/classfeedback/send",
    method: "post",
});
configs.push({
    key: "classfeedbackrecord",
    path: "/api/classfeedbackrecord/list",
    method: "get",
});
configs.push({
    key: "noClassNoticerecord",
    path: "/api/noClassNoticerecord/list",
    method: "get",
});
configs.push({
    key: "autoclassrecord",
    path: "/api/autoClassRecord/list",
    method: "get",
});
// 测试不同短口接口
configs.push({
    key: "test",
    path: "/test/test",
    method: "get",
    type: "java",
});

//学校列表
configs.push({
    key: "schoolList",
    path: "/system/school/list",
    method: "get",
    type: "java",
});
//学校不分页列表
configs.push({
    key: "schoolListAll",
    path: "/system/school/listAll",
    method: "get",
    type: "java",
});
//添加
configs.push({
    key: "schoolAdd",
    path: "/system/school",
    method: "post",
    type: "java",
});
//学校修改
configs.push({
    key: "schoolEdit",
    path: "/system/school",
    method: "put",
    type: "java",
});

//学校删除
configs.push({
    key: "schoolDel",
    path: "/system/school",
    method: "delete",
    type: "java",
});
// 学校负责人列表
configs.push({
    key: "schoolManageList",
    path: "/system/school/head/list",
    method: "get",
    type: "java",
});
// 学校负责人新增
configs.push({
    key: "schoolManageAdd",
    path: "/system/school/head",
    method: "post",
    type: "java",
});
// 学校负责人修改
configs.push({
    key: "schoolManageEdit",
    path: "/system/school/head",
    method: "put",
    type: "java",
});
// 学校负责人删除
configs.push({
    key: "schoolManageDel",
    path: "/system/school/head/{ids}",
    method: "put",
    type: "java",
});

//用户注册
configs.push({
    key: "UserAdd",
    path: "/system/sysUser",
    method: "post",
    type: "java",
});
//用户列表
configs.push({
    key: "UserList",
    path: "/system/sysUser/list",
    method: "get",
    type: "java",
});
//用户列表不分页
configs.push({
    key: "userListAll",
    path: "/system/sysUser/listAll",
    method: "get",
    type: "java",
});
//用户新增
configs.push({
    key: "userAdd",
    path: "/system/sysUser",
    method: "post",
    type: "java",
});
//用户修改
configs.push({
    key: "userEdit",
    path: "/system/sysUser",
    method: "put",
    type: "java",
});
//绑定关系列表
configs.push({
    key: "RelationList",
    path: "/system/relation/list",
    method: "get",
    type: "java",
});
//绑定关系修改
configs.push({
    key: "RelationEdit",
    path: "/system/relation",
    method: "put",
    type: "java",
});
//绑定关系新增（家长信息）
configs.push({
    key: "RelationAdd",
    path: "/system/relation",
    method: "post",
    type: "java",
});
//绑定关系新增（儿童信息）
configs.push({
    key: "RelationBindStudent",
    path: "/system/sysUser/listForBind",
    method: "get",
    type: "java",
});

//活动管理
//活动列表
configs.push({
    key: "activityList",
    path: "/activity/page",
    method: "post",
    type: "java",
});
//活动新增
configs.push({
    key: "activityListAdd",
    path: "/activity",
    method: "put",
    type: "java",
});

//志愿者列表
configs.push({
    key: "volunteerList",
    path: "/system/sysUser/listAll?rid=volunteer",
    method: "get",
    type: "java",
});



//资料管理
//资料列表
configs.push({
    key: "dataList",
    path: "/system/file/list",
    method: "get",
    type: "java",
});
//资料下载记录
configs.push({
    key: "dataRecord",
    path: "/system/log/list",
    method: "get",
    type: "java",
});

//提醒管理
//提醒任务列表
configs.push({
    key: "smsTaskList",
    path: "/sms_task/page",
    method: "post",
    type: "java",
});
//提醒任务新增
configs.push({
    key: "smsTaskAdd",
    path: "/sms_task",
    method: "put",
    type: "java",
});
//提醒消息列表
configs.push({
    key: "msgList",
    path: "/sms_task/msg/page",
    method: "post",
    type: "java",
});

// 公共下载接口
configs.push({
    key: "commonDownload",
    path: "/common/download",
    method: "get",
    type: "java",
});



[
    "course",
    "courseware",
    "subject",
    "user",
    "role",
    "version",
    "feedback",
    "classification",
    "article",
    "log",
    "file",
    "question",
    "work",
    "video",
    "permit",
    "friend",
    "application",
    "chatgroup",
    "groupmember",
    "relation",
    "rate",
    "project",
    "autoClass",
    "noClassNotice",
    "classfeedback",
].forEach((model) => {
    configs.push({
        key: `${model}List`,
        path: `/api/${model}/list`,
        method: "get",
    });
    configs.push({
        key: `${model}Detail`,
        path: `/api/${model}/detail`,
        method: "get",
    });
    configs.push({
        key: `${model}Remove`,
        path: `/api/${model}/remove`,
        method: "post",
    });
    configs.push({
        key: `${model}Append`,
        path: `/api/${model}/append`,
        method: "post",
    });
    configs.push({
        key: `${model}Update`,
        path: `/api/${model}/update`,
        method: "post",
    });
});

configs.forEach((o) => {
    if (o.method === "get") {
        objs[o.key] = (params) =>
            (o.type ? $jHttp : $http).get(o.path, {
                params,
            });
    } else if (o.method === "post") {
        objs[o.key] = (data, pageSize) => (o.type ? $jHttp : $http).post(o.path, data, pageSize);
    } else if (o.method === "put") {
        objs[o.key] = (data) => (o.type ? $jHttp : $http).put(o.path, data);
    }
});

// configs.forEach(o => {
//   if (o.method === 'get') {
//     objs[o.key] = params => $http.get(`${o.type ? '/japi' + o.path : o.path}`, {
//       params
//     })
//   } else {
//     objs[o.key] = data => $http.post(`${o.type ? '/japi' + o.path : o.path}`, data);
//   }
// });

Vue.prototype.$api = objs;
Vue.prototype.$apiConfigs = configs;